export enum DineInServingOptions {
  HIDE = 'false',
  SHOW = 'true',
}
